import React, { useState, useEffect } from "react";
import SecurityIcon from "../../assets/png/security.png";
import Sidebar from "../../Components/Sidebar/Sidebar";

import "./Twofa1.css";
import Navbar from "../../Components/Navbar/Navbar";
import { servicePost } from "../../helper/api";
import Button from "../../Components/UIComponents/Button";

const DisableRequest = () => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("wealth_user"))?.data
  );

  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const reqDisable = async () => {
    try {
      setIsLoading(true);
      const twoFaDisableReq = await servicePost(
        "admin2fa/twofaDisableRequest",
        {
          email: user?.email,
        },
        notification,
        authToken
      );

      if (twoFaDisableReq.message == "SUCCESS") {
        setModalShow(true);
        setIsLoading(false);

        const updatedUser = {
          ...user,
          enableOn: false,
          twoFaRequest: true,
        };

        localStorage.setItem(
          "wealth_user",
          JSON.stringify({ data: updatedUser })
        );

        setTimeout(() => {
          setModalShow(false);
        }, 3000);
      }
      setIsLoading(false);
    } catch (error) {
      setError(true);
      setIsLoading(false);
      setErrorMessage("Something went wrong.");
      setTimeout(() => {
        setErrorMessage("");
        setError(false);
      }, 5000);
    }
  };

  return (
    <>
      <Navbar />
      <div className="twofa-guide-wrapper navbar-space-wrapper admin-sidebar-space">
        <Sidebar />
        <div className="container">
          <div className="transfer-history-header">
            <img src="./images/icons/enable-icon-1.png" alt="icon" />
            <h3 className="twofa-desktop"> Two-Factor Authentication</h3>
            <h3 className="twofa-mobile-header"> 2F Authentication</h3>
          </div>
          <div className="twofa-enable-wrapper dashboard-twofa-enable-wrapper">
            <div className="twofa-status-wrapper">
              <img src="./images/twofa-disable-req.png" alt="icon" />
              <p className="twofa-status"> Status </p>
              <h2 className="disable-request">
                Email has been Sent to disable
              </h2>

              <div className="resend-email-btn">
                <Button
                  isLoading={isLoading}
                  label="Resend email"
                  onClick={reqDisable}
                />
              </div>
            </div>
            <div className="twofa-footer">
              <div className="twofa-security-wrapper">
                <div className="twofa-security-wrap">
                  <img src={SecurityIcon} alt="icon" />
                  <p>
                    If you request to disable your 2FA, then you check the
                    status showing request to disable.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisableRequest;
